/* Cosa Nostraa — variant-aware gallery filter + reset + single-line pills expand.
   Gallery (STRICT): the gallery shows ONLY the selected variant's photos,
   matched on the image alt text, which carries the variant title (e.g. the
   "SKU Design Name" convention). Anything else hides. Reset re-checks the
   default variant, which restores that variant's photos only.
   Pills: the fieldset is a single nowrap line with hidden overflow; the
   Show more control appears only when the row overflows and swaps to Show
   less while expanded.
   DAWN RE-RENDER CAVEATS (this file works around both):
   1. On variant change Dawn's HTMLUpdateUtility replaces the whole
      variant-selects innerHTML — including the reset button and the pills
      row. So NO direct element listeners survive a swap: the Reset button
      and the Show more button are handled by ONE delegated document-level
      click listener, and pills expanded/collapsed state lives in openState
      (JS, per picker), re-applied onto the fresh markup after every swap.
   2. Dawn's swap utility fires no event of its own — a light poll keyed on
      the picker markup changing catches the swap even when neither the
      pubsub variantChange event nor shopify:section:load fires for it. */
(function () {
  'use strict';
  var HIDE = 'cn-variant-hidden';
  var OPEN = 'cn-pills-open';
  var defaultValue = null;
  var openState = {};

  function picker() { return document.querySelector('variant-selects'); }
  function fieldset() {
    var p = picker();
    if (!p) return null;
    return p.querySelector('fieldset.product-form__input--pill') ||
           p.querySelector('fieldset.product-form__input');
  }
  function radios() {
    return Array.prototype.slice.call(document.querySelectorAll('variant-selects input[type=radio]'));
  }
  function checkedRadio() { return document.querySelector('variant-selects input[type=radio]:checked'); }
  function selectedTitle() {
    var r = checkedRadio();
    return r ? (r.value || '').trim().toLowerCase() : '';
  }
  function galleryItems() {
    return Array.prototype.slice.call(document.querySelectorAll('media-gallery li[data-media-id], .product__media-list li[data-media-id]'));
  }
  function moreRow() {
    var fs = fieldset();
    return fs && fs.nextElementSibling && ('' + fs.nextElementSibling.className).indexOf('cn-pills-more-row') !== -1
      ? fs.nextElementSibling : null;
  }

  function apply() {
    var title = selectedTitle();
    if (!title) return;
    var isDefault = defaultValue !== null && title === (defaultValue || '').toLowerCase();
    var first = null;
    galleryItems().forEach(function (li) {
      var img = li.querySelector('img');
      var alt = (img && img.getAttribute('alt')) || '';
      var match = alt.toLowerCase().indexOf(title) !== -1;
      li.classList.toggle(HIDE, !match);
      if (match && !first) first = li;
    });
    var viewer = document.querySelector('media-gallery [id^="GalleryViewer"] ul, media-gallery .product__media-list');
    if (first && viewer) {
      window.setTimeout(function () {
        try { viewer.scrollTo({ left: first.offsetLeft, behavior: 'smooth' }); } catch (e) {}
      }, 80);
    }
    var btn = document.querySelector('[data-cn-variant-reset]');
    if (btn) btn.hidden = isDefault;
  }

  /* Programmatic re-check of the default radio + a bubbling change event;
     Dawn's own handler picks it up, re-renders the section, and the
     pubsub/poll path re-applies the gallery + pills state. */
  function doReset() {
    var target = radios().filter(function (r) {
      return (r.value || '').trim().toLowerCase() === (defaultValue || '').toLowerCase();
    })[0];
    if (!target) { apply(); return; }
    if (target.checked) { apply(); return; }
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    /* Belt and braces: if Dawn's own handler misses the synthetic event,
       force the section state ourselves shortly after. */
    window.setTimeout(function () { apply(); renderPills(); }, 260);
    window.setTimeout(function () { apply(); renderPills(); }, 700);
  }

  function pillsKey() {
    var p = picker();
    return p ? (p.dataset.section || p.id || 'default') : 'default';
  }
  function isOpen() { return !!openState[pillsKey()]; }
  function setOpen(v) { openState[pillsKey()] = !!v; }

  function renderPills() {
    var fs = fieldset();
    var row = moreRow();
    if (!fs || !row) return;
    var btn = row.querySelector('[data-cn-pills-more]');
    var label = btn ? btn.querySelector('[data-cn-pills-label]') : null;
    if (!btn) return;
    var open = isOpen();
    fs.classList.toggle(OPEN, open);
    if (open) {
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = 'Show less';
      return;
    }
    fs.classList.remove(OPEN);
    var overflow = fs.scrollWidth > fs.clientWidth + 4;
    btn.hidden = !overflow;
    btn.setAttribute('aria-expanded', 'false');
    if (label) label.textContent = 'Show more';
  }

  /* ONE delegated click listener for BOTH controls — delegated listeners
     sit on document and survive Dawn's innerHTML swaps, which is why the
     old per-element Reset binding went dead after the first selection. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var resetBtn = e.target.closest('[data-cn-variant-reset]');
    if (resetBtn) { doReset(); return; }
    var moreBtn = e.target.closest('[data-cn-pills-more]');
    if (moreBtn) { setOpen(!isOpen()); renderPills(); }
  });
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(renderPills, 120);
  });
  window.addEventListener('load', renderPills);

  function start() {
    var p = picker();
    if (!p) return;
    if (defaultValue === null) {
      var c = checkedRadio();
      defaultValue = c ? (c.value || '').trim() : '';
    }
    p.addEventListener('change', function () {
      window.setTimeout(function () { apply(); renderPills(); }, 90);
    });
    apply();
    renderPills();
  }

  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(function () { apply(); renderPills(); }, 160);
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  document.addEventListener('shopify:section:load', start);
  var swapped = 0;
  window.setInterval(function () {
    var fs = fieldset();
    if (!fs) return;
    var stamp = fs.outerHTML.length + radios().length;
    if (stamp !== swapped) {
      swapped = stamp;
      window.setTimeout(function () { apply(); renderPills(); }, 60);
    }
  }, 250);
})();
